import HeaderContent from '@/components/sections/builder/elements/header/header/content/index';
import { ElementProps } from '@/components/sections/builder/types';

export default function ElementContent({ element, preview, theme }: ElementProps) {
  return <HeaderContent element={element} preview={preview} theme={theme} />;
}
